import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleAuthGuard } from '@app/role.guard';
// import { Shell } from '@app/shell/shell.service';
import { HomeComponent } from './home.component';

const routes: Routes = [  
  { 
    path: '', 
    redirectTo: 'dashboard', 
    pathMatch: 'full' 
  },
  {
    path: 'dashboard',
    component: HomeComponent,
    canActivate: [RoleAuthGuard],
    data: { title: 'Covid Dashboard' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class HomeRoutingModule {}
